import { Component, OnInit } from '@angular/core';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-image-cell',
    templateUrl: './image-cell.component.html',
    styleUrls: ['./image-cell.component.scss'],
    standalone: false
})
export class ImageCellComponent implements OnInit {
  imageUrl: any;

  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    const value = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    if (!value) {
      this.imageUrl = null;
      return;
    }

    this.imageUrl = value;
  }
}
